<template>
	<div>
		<p>当前正在进行第 {{ current+1 }} 步</p>
		<Steps :current="current">
			<Step title="步骤-1" content="选择筛选方式" icon="ios-search"></Step>
			<Step title="步骤-2" content="填写发送内容" icon="md-text"></Step>
			<Step title="步骤-3" content="推送用户列表" icon="ios-people"></Step>
			<Step title="步骤-4" content="执行" icon="ios-checkmark-circle"></Step>
		</Steps>
        <Spin fix v-show="isSpinFirstShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
		<div style="width:30%; left:30%; position:relative; margin-top:15px;" v-show="showStep1">
	      	<Form ref="formValidate" :label-width="100" :model="formValidateItem" :rules="ruleValidateItem">
				<FormItem label="推送角色：" prop="selectCharacter">
					<Select v-model="formValidateItem.selectCharacter" @on-change="onSelectCharacter">
						<Option value="customer">向燃气用户推送</Option>
						<Option value="security">向安全负责人推送</Option>
						<Option value="engineers">向工程人员推送</Option>
					</Select>
				</FormItem>
				<FormItem label="区域选择：" prop="cascaderArea">
					<Cascader v-model="formValidateItem.cascaderArea" :data="areaData" change-on-select 
						filterable transfer @on-change="choiceAll"></Cascader>
				</FormItem>
	      	</Form>
	    </div>
	    <div style="width:40%; left:25%; position:relative; margin-top:15px;" v-show="showStep2">
	    	<Form ref="formPush" :label-width="100" :model="formPushItem" :rules="rulePushItem">
				<FormItem label="推送标题：" prop="title">
					<Input v-model="formPushItem.title" placeholder="请输入推送标题..."></Input>
				</FormItem>
				<FormItem label="推送内容：" prop="content">
					<Input v-model="formPushItem.content" type="textarea" placeholder="请输入推送内容..." :autosize="{minRows: 2,maxRows: 10}"></Input>
				</FormItem>
				<FormItem label="推送时间：" prop="date">
					<Input disabled v-model="formPushItem.date"></Input>
				</FormItem>
				<FormItem label="发布人：" prop="publisher">
					<Input disabled v-model="formPushItem.publisher" placeholder="请输入发布人..."></Input>
				</FormItem>
	      	</Form>
	    </div>
	    <div style="width:90%; left:5%; position:relative; margin-top:15px;" v-show="showStep3">
	    	<Spin fix v-show="isSpinShow">
		       <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
		       <div>Loading</div>
		    </Spin>
	      	<Table ref="selection" :data="showData" :columns="showColumns" stripe></Table>
		    <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer 
		    	show-total @on-change="changePage" @on-page-size-change="changePageSize" ></Page>
	    </div>
	    <div style="width:60%; left:20%; text-align:center; position:relative; margin-top:15px;" >
	    	<expandStep4 ref="step4" :result="result" :msg="msg" 
	    		:on-ok="callBackReturn" v-if="showStep4"></expandStep4>
	    </div>
		<div>
			<Button class="button" type="primary" @click="pre" :disabled="disabledButtonPre">上一步</Button>
			<Button class="button" type="primary" @click="next" :disabled="disabledButtonNext" style="margin-left: 10px;">下一步</Button>
		</div>
		<Modal v-model="isShowModal" width="340" >
			<h3>点击确定将给这{{dataCount}}个用户推送</h3>
			<h3>是否确定？</h3>
			<div slot="footer">
				<Button type="info" size="large" :loading="modalLoading" long @click="ok">确定</Button>
			</div>
		</Modal>
	</div>
	
</template>

<script>
import expandStep4 from "./expand/opResult.vue";
export default {
	name: "push_msg",
	components: {expandStep4},
	created() {
		var that = this;
        that.isSpinFirstShow = true;
		//地址树
		$.ajax({
			url: "/api/getAddressTree",
			contentType: "application/json",
			type: "get",
			dataType: "json",
			success: function(data) {
				if(data.errorCode != 0) {
					that.$Notice.error({
						title: "异常",
						desc: data.errorInfo
					});
					return;
				}
				that.addressData = data.body[0].children;
			},
			error: function(textStatus) {
				that.$Notice.error({
					title: "异常",
					desc: "接口请求异常"
				});
			},
            complete: function(){
                that.isSpinFirstShow = false;
            }
		});
		//管辖机构树
		$.ajax({
			url: "/api/getGoveringBodyTree",
			contentType: "application/json",
			type: "get",
			dataType: "json",
			success: function(data) {
				if(data.errorCode != 0) {
					that.$Notice.error({
						title: "异常",
						desc: data.errorInfo
					});
					return;
				}
				that.goveringBodyData = data.body[0].children;
			},
			error: function(textStatus) {
				that.$Notice.error({
					title: "异常",
					desc: "接口请求异常"
				});
			}
		});
		//当前登录人
		// $.ajax({
		// 	url: "/api/login",
		// 	contentType: "application/json",
		// 	type: "get",
		// 	dataType: "json",
		// 	success: function(data) {
		// 		if(data.errorCode != 0) {
		// 			that.$Notice.error({
		// 				title: "异常",
		// 				desc: data.errorInfo
		// 			});
		// 			return;
		// 		}
		// 		that.formPushItem.publisher = data.body;
		// 	},
		// 	error: function(textStatus) {
		// 		that.$Notice.error({
		// 			title: "异常",
		// 			desc: "接口请求异常"
		// 		});
		// 	}
		// });
		this.formPushItem.publisher = localStorage.getItem("userAccount");
	},
	mounted() {
	    let _this = this; 
	    this.timer = setInterval(() => {
	        _this.formPushItem.date = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date());
	    }, 1000)
	},
    beforeDestroy() {
        if (this.timer) {
	        clearInterval(this.timer); 
	    }
    },
	data() {
		const validateAddress = (rule, value, callback) => {
            if (value.length === 0) {
                callback(new Error('请选择推送区域...'));
            } else {
                callback();
            }
        };
		return {
            isSpinFirstShow: false,
			result: "",
			msg: "",
			disabledButtonPre: true,
			disabledButtonNext: false,
			modalLoading: false,
			isSpinShow: false,
			current: 0,
			showStep1: true,
			showStep2: false,
			showStep3: false,
			showStep4: false,
			addressData: [],
			goveringBodyData: [],
			areaData: [],
			viewCustomerDetailed: {
				addressLowestLevelAddressId: ""
			},
			viewPersonnelDetailed: {
				governingBodyId: ""
			},
			showData: [],
			totalCustomerDetailedData: [],
			totalPersonnelDetailedData: [],
			showColumns: [],
			showCustomerColumns: [
				{
					title: "用户姓名",
					key: "customerName",
					width: 100
				},
				{
					title: "电话",
					key: "customerPhone"
				},
				{
					title: "地址",
					key: "addressLowestLevelAddressIds",
					width: 400
				},
				{
					title: "表号",
					key: "meterId"
				},
				{
					title: "管辖机构",
					key: "governingBodyName"
				}
			],
			showGoverningColumns: [
				{
					title: "员工姓名",
					key: "personnelName",
					width: 100
				},
				{
					title: "员工编号",
					key: "personnelSeriesNumber"
				},
				{
					title: "电话",
					key: "personnelPhone"
				},
				{
					title: "身份证",
					key: "personnelIdcard"
				},
				{
					title: "所属部门",
					key: "governingBodyName"
				},
				{
					title: "备注",
					key: "personnelRemark"
				}
			],
			currentPage: 1,
			dataCount: 0,
			pageSize: 10,
			isShowModal: false,
			formValidateItem: {
				selectCharacter: "",
				cascaderArea: []
			},
			formPushItem: {
				title: "",
				content: "",
				date: global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date()),
				publisher: ""
			},
			ruleValidateItem:{
				selectCharacter: [
					{ required: true, message: '请选择推送角色...', trigger: 'change' }
				],
				cascaderArea: [
					{ required: true, validator: validateAddress, trigger: 'change' }
				]
			},
			rulePushItem:{
				title: [
					{ required: true, message: '请输入推送标题...', trigger: 'blur' }
				],
				content: [
					{ required: true, message: '请选择推送内容...', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		next() {
			if(this.current == 3) {
				
			} else if(this.current == 0) {
				var that = this;
				that.$refs['formValidate'].validate((valid) => {
					if (valid) {
						that.current += 1;
						that.showStep1 = false;
						that.showStep2 = true;
						that.disabledButtonPre = false;
					}
				});
			} else if(this.current == 1) {
				var that = this;
				that.$refs['formPush'].validate((valid) => {
					if (valid) {
						that.getShowData();
						that.showStep2 = false;
						that.showStep3 = true;
						that.current += 1;
					}
				});
			} else if(this.current == 2) {
				this.isShowModal = true;
			} else {
				this.current += 1;
			}
		},
		pre() {
			if(this.current == 0) {
				
			} else if(this.current == 1) {
				this.showStep1 = true;
				this.showStep2 = false;
				this.current -= 1;
				this.disabledButtonPre = true;
			} else if(this.current == 2) {
				this.showStep2 = true;
				this.showStep3 = false;
				this.current -= 1;
			} else if(this.current == 3) {
				this.showStep3 = true;
				this.showStep4 = false;
				this.current -= 1;
			} else {
				this.current -= 1;
			}
		},
		choiceAll(data) {
			if(data.length > 0 && this.formValidateItem.selectCharacter == "customer") {
				this.viewCustomerDetailed.addressLowestLevelAddressId = data[data.length - 1];
			} else if(data.length > 0 && (this.formValidateItem.selectCharacter == "security"
										||this.formValidateItem.selectCharacter == "engineers")) {
				this.viewPersonnelDetailed.governingBodyId = data[data.length - 1];
			}else {
				this.viewCustomerDetailed.addressLowestLevelAddressId = null;
				this.viewPersonnelDetailed.governingBodyId = null;
			}
		},
		onSelectCharacter(param) {
			this.formValidateItem.cascaderArea = [];
			if(param == "customer") {
				this.areaData = this.addressData;
				this.showColumns = this.showCustomerColumns;
			} else {
				this.areaData = this.goveringBodyData;
				this.showColumns = this.showGoverningColumns;
			}
		},
		getShowData(){
			var that = this;
			this.isSpinShow = true;
			if (that.formValidateItem.selectCharacter == "customer") {
				$.ajax({
					url: "/api/baseInfo/getViewCustomerDetailedPage?page=" +
						this.currentPage +
						"&pageAmount=" +
						this.pageSize,
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify(that.viewCustomerDetailed),
					success: function(data) {
						if(data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.showData = data.body.resultList;
						that.dataCount = data.body.amount;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
				//获取条件筛选全部的用户数据
				$.ajax({
					url: "/api/baseInfo/getViewCustomerDetailedPage?page=0&pageAmount=" +
						this.pageSize,
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify(that.viewCustomerDetailed),
					success: function(data) {
						if(data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.totalCustomerDetailedData = data.body.resultList;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
                    complete:function(){
                        that.isSpinShow = false;
                    }
				});
			} else if (that.formValidateItem.selectCharacter == "security"
						||that.formValidateItem.selectCharacter == "engineers") {
				$.ajax({
					url: "/api/baseInfo/getViewPersonnelDetailedPage?page=" +
						this.currentPage +
						"&pageAmount=" +
						this.pageSize,
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify(that.viewPersonnelDetailed),
					success: function(data) {
						if(data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.showData = data.body.resultList;
						that.dataCount = data.body.amount;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
				//获取条件筛选全部的安全负责人数据
				$.ajax({
					url: "/api/baseInfo/getViewPersonnelDetailedPage?page=0&pageAmount=" +
						this.pageSize,
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify(that.viewPersonnelDetailed),
					success: function(data) {
						if(data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						that.totalPersonnelDetailedData = data.body.resultList;
						that.isSpinShow = false;
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			}
		},
		changePage(index) {
			this.currentPage = index;
			this.getShowData();
		},
		changePageSize(size) {
			this.pageSize = size;	
			this.getShowData();
		},
		ok() {
			var that = this;
			var openIds = "";
			that.modalLoading = true;
			if (that.formValidateItem.selectCharacter == "customer") {
				that.totalCustomerDetailedData.map(item=>{
					if (item.customerWechatId != null) {
						openIds = openIds == "" ? item.customerWechatId : openIds + "," + item.customerWechatId;
					}
				});
			} else if (that.formValidateItem.selectCharacter == "security"
						||that.formValidateItem.selectCharacter == "engineers") {
				that.totalPersonnelDetailedData.map(item=>{
					if (item.personnelWechatId != null) {
						openIds = openIds == "" ? item.personnelWechatId : openIds + "," + item.personnelWechatId;
					}
				});
			}
			that.formPushItem["openIds"] = openIds;
			$.ajax({
				url: "/api/pushMsgFromPC",
				contentType: "application/json",
				type: "post",
				dataType: "json",
				data: JSON.stringify(that.formPushItem),
				success: function(data) {
					if(data.errorCode != 0) {
						that.$Notice.error({
							title: "异常",
							desc: data.errorInfo
						});
						that.result = "fail";
						that.msg = "推送失败" + data.errorInfo;
						that.modalLoading = false;
						that.isShowModal = false;
						that.showStep3 = false;
						that.showStep4 = true;
						that.current += 1;
						that.disabledButtonPre = false;
						that.disabledButtonNext = false;
						return;
					}
					that.result = "success";
					that.msg = "推送成功，点击返回"
					that.modalLoading = false;
					that.isShowModal = false;
					that.showStep3 = false;
					that.showStep4 = true;
					that.current += 1;
					that.disabledButtonPre = false;
					that.disabledButtonNext = false;
				},
				error: function(textStatus) {
					that.$Notice.error({
						title: "异常",
						desc: "接口请求异常"
					});
				}
			});
			
		},
		callBackReturn(){
	    	this.current = 0;
		    this.disabledButtonNext = false;//按钮可用
		    this.disabledButtonPre = true;
		    this.showStep1 = true;
		    this.showStep2 = false;
		    this.showStep3 = false;
		    this.showStep4 = false;
	    }
	}
}


</script>

<style scope>
.ivu-cascader-menu .ivu-cascader-menu-item i {
	right: 5px;
}
.ivu-table-large th {
    height: 30px;
}
.ivu-table-large td {
    height: 30px;
}
.ivu-table td, .ivu-table th {
    min-width: 0;
    height: 30px;
    box-sizing: border-box;
    text-align: center;
    text-overflow: ellipsis;
    vertical-align: middle;
    border-bottom: 1px solid #e8eaec;
}
</style>